module.exports = __webpack_public_path__ + "img/70100004.d4e7ffc0.png";